import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BlujayUrl } from './blujay-url.model';
import { HttpUtils } from '../../shared/http-utils';
import { Observable, of } from 'rxjs';
import { URL_BASE } from '../../core/constants';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class BlujayUrlService {

  private blujayUrls: BlujayUrl[] = [];
  private loaded                  = false;

  constructor(private http: HttpClient) {
  }

  public fetchAll(): Observable<BlujayUrl[]> {
    const headers = HttpUtils.createHeaders();
    return this.http.get(URL_BASE + '/api/blujayUrls', { headers })
      .pipe(
        tap(() => this.loaded = true),
        map((result: any[]) => {
          this.blujayUrls = result.map(blujayUrl => new BlujayUrl(
            blujayUrl.name,
            blujayUrl.label
          ));

          return this.blujayUrls;
        })
      );
  }

  public getAll(): Observable<BlujayUrl[]> {
    if (this.loaded) {
      return of(this.blujayUrls);
    }

    return this.fetchAll();
  }

}
